import { useNavigate } from "@tanstack/react-router";
import { IconArrowLeft } from "@tabler/icons-react";
import { AdminPageHeader, Button } from "@/components/ui";

export function AuditoriaHeader() {
  const navigate = useNavigate();
  return (
    <AdminPageHeader
      title="Auditoría"
      description="Registro inmutable de actividad sensible · solo Auditor y Administrador (decisión 29)."
      actions={
        <Button variant="default" leftSection={<IconArrowLeft size={14} />} onClick={() => void navigate({ to: "/admin" })}>
          Volver
        </Button>
      }
    />
  );
}
